import Quill from "quill";
import "./blot.less";
const Embed = Quill.import("blots/embed");

/**
 * PiLinkBlot 显示
 */
class PiLinkBlot extends Embed {
  /**
   * 返回dom
   */
  static create(data) {
    const node = super.create();
    const piLinkSpan = document.createElement("span");
    piLinkSpan.className = "piLink-inner";
    piLinkSpan.innerHTML = data.title || "无标题";
    node.appendChild(piLinkSpan);
    return PiLinkBlot.setDataValues(node, data);
  }

  /**
   * 设置值到dataset 方便拿
   */
  static setDataValues(element, data) {
    const domNode = element;
    Object.keys(data).forEach(key => {
      domNode.dataset[key] = data[key];
    });
    return domNode;
  }
  static value(domNode) {
    return domNode.dataset;
  }

  /**
   * 这两个方法要用 得调super.attach
   */
  // // 安装
  // attach() {}
  // // 销毁
  // detach() {}
}
PiLinkBlot.blotName = "piLink";
PiLinkBlot.tagName = "span";
PiLinkBlot.className = "piLink";
export default PiLinkBlot;